import axios from "axios";
const chatbot = "/bp/api/chatbot";
// Helper function to get auth headers
const getAuthHeaders = (token, isFormData = false) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  return { headers };
};

export const createSession = async (token, moduleId = null) => {
  try {
    const requestBody = {};
    if (moduleId) {
      requestBody.module_id = moduleId;
    }

    const response = await axios.post(
      `${chatbot}/session`,
      requestBody,
      getAuthHeaders(token)
    );
    return response.data.session_id;
  } catch (error) {
    throw new Error("Failed to create a new session");
  }
};

export const getSessions = async (token, page = 1, moduleId = null) => {
  try {
    const params = new URLSearchParams({
      page_number: page.toString(),
    });

    if (moduleId) {
      params.append("module_id", moduleId.toString());
    }

    const response = await axios.get(
      `${chatbot}/session?${params.toString()}`,
      getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to load sessions");
  }
};

export const getmodule = async (token) => {
  try {
    const response = await axios.get(
      `${chatbot}/module`,
      getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to load modules");
  }
};

export const getMessages = async (token, sessionId) => {
  try {
    const response = await axios.get(
      `${chatbot}/chat?session_id=${sessionId}`,
      getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to load messages");
  }
};

export const sendMessage = async (token, data) => {
  try {
    const response = await axios.post(
      `${chatbot}/chat`,
      data,
      getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to send message");
  }
};

export const addModule = async (token, data) => {
  const response = await axios.post(
    `${chatbot}/module`,
    data,
    getAuthHeaders(token, true)
  );
  return response.data;
};

export const deleteModule = async (token, data) => {
  try {
    const response = await axios.delete(
      `${chatbot}/module/${data.id}`,
      getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to delete module");
  }
};

export const deleteSession = async (token, data) => {
  try {
    const response = await axios.delete(
      `${chatbot}/session/${data.id}`,
      getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to delete session");
  }
};

export const sendStreamingMessage = async (token, messageData, onChunk) => {
  try {
    const response = await fetch(`${chatbot}/async_chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(messageData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    if (!response.body) {
      throw new Error("ReadableStream not yet supported in this browser.");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let done = false;
    let accumulatedContent = "";

    while (!done) {
      const { value, done: doneReading } = await reader.read();
      done = doneReading;

      if (value) {
        const chunk = decoder.decode(value);

        if (chunk.startsWith("data: ")) {
          const jsonData = chunk.slice(6).trim();
          if (jsonData === "[DONE]") {
            done = true;
            break;
          }
          try {
            const parsed = JSON.parse(jsonData);
            const content =
              parsed.content || parsed.message || parsed.text || "";
            accumulatedContent += content;

            // Call the callback with the accumulated content
            if (onChunk) {
              onChunk(accumulatedContent);
            }
          } catch {
            accumulatedContent += jsonData;
            if (onChunk) {
              onChunk(accumulatedContent);
            }
          }
        } else {
          accumulatedContent += chunk;
          if (onChunk) {
            onChunk(accumulatedContent);
          }
        }
      }
    }

    return accumulatedContent;
  } catch (error) {
    throw new Error(`Failed to send streaming message: ${error.message}`);
  }
};
